__turbopack_context__.v({
  "indicator": "SectionTitle-module-scss-module__SntYYa__indicator",
  "title": "SectionTitle-module-scss-module__SntYYa__title",
  "titleContainer": "SectionTitle-module-scss-module__SntYYa__titleContainer",
});
